/**
 * ecoTrack — учёт кликов по кросс-ссылкам на соседние продукты экосистемы.
 *
 * Замеряем гипотезу «дети переходят из Рублокса в Майнкрафтию и Маську».
 * Используем уже подключённый самописный трекёр metrika.js (window.mtrk):
 * тип 'event' в whitelist бэкенда, событие попадает в metrika_events
 * (site='rublox', event_name='eco_click_<product>') с visitor_id/user_id.
 * Никаких изменений бэкенда метрики не требуется.
 *
 * product — 'maska' | 'minecraftia'
 * place   — где кликнули: 'landing_block' | 'feed_promo' | 'more_menu' |
 *           'footer' | 'sidebar' | 'comments_cta' | 'studio_header' |
 *           'player_help' и т.п.
 */

// Канонические публичные адреса продуктов экосистемы.
export const ECO_URLS = {
  minecraftia: "https://minecraftia-school.ru",
  maska: "https://маська.рф",
};

export function trackEcoClick(product, place, url) {
  try {
    if (window.mtrk) {
      window.mtrk("event", `eco_click_${product}`, {
        place: place || "",
        href: url || ECO_URLS[product] || "",
      });
    }
  } catch (e) {
    /* трекинг не должен ломать переход */
  }
}

/**
 * Открыть продукт экосистемы в новой вкладке с учётом клика.
 * Удобно для onClick на кнопках/пунктах меню.
 */
export function openEco(product, place) {
  const url = ECO_URLS[product];
  trackEcoClick(product, place, url);
  window.open(url, "_blank", "noopener,noreferrer");
}
